import queryString from 'query-string';

const absoluteUrlPattern = /^https?:\/\//i;
export function isAbsoluteUrl(url?: string) {
  if (!url) {
    return false;
  }

  return absoluteUrlPattern.test(url);
}

export function isJsfUrl(url?: string) {
  if (!url) {
    return false;
  }

  const path = url.split(/[?#]/)[0]; // trim any optional query parameters and/or fragment/hash
  return path.includes('.seam') || path.includes('/show/') || path.includes('/perform/');
}

export function isExternalAuthWall() {
  const parsedQueryString = queryString.parse(window.location.search);
  const { authWall } = parsedQueryString;

  if (!authWall) {
    return false;
  }
  return ['ExternalHREF', 'JSFHREF', 'documentation'].includes(authWall.toString());
}

export function isExternalUrl(url?: string) {
  return isAbsoluteUrl(url) || isJsfUrl(url) || isExternalAuthWall();
}

export function isFileDownloadUrl(url?: string) {
  if (!url) {
    return false;
  }

  return url.includes('fileDownloadToken=') && !url.includes('asRESTResource=');
}

/** Use param given value if it is set otherwise default to defaultValue */
export const getQueryParam = <T>(value: string | (string | null)[] | null, defaultValue: T) => (
  value ? value as unknown as T : defaultValue
);
